import React, { useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';

export const LoopOverHooks = ({ id, filter, onDataAvailable }) => {
  const selectionOptionKey = id.toUpperCase();
  const { data } = useDataModel('fitmentOptionsV1', {
    variables: {
      fitmentType: 'AUTOMOTIVE',
      optionType: selectionOptionKey,
      filter
    }
  });

  useEffect(() => {
    if (data?.fitmentOptionsV1?.options) {
      onDataAvailable(selectionOptionKey, data.fitmentOptionsV1.options);
    }
  }, [JSON.stringify(data?.fitmentOptionsV1?.options)]);

  return null;
};